import css from './Space.module.css'

import { Box, type BoxProps } from '@/components/Box/Box'

export function Space(props: BoxProps) {
    return <Box className={css.space} {...props} />
}
